import * as types from './mutation-types';

export const incrementAmount = ({ commit }, { shop, amount }) => {
        commit(types.INCREMENT_AMOUNT, {
            shop,
            amount
        });
    },
    buildBranches = ({ commit }, { shop, amount }) => {
        commit(types.BUILD_BRANCHES, { shop, amount });
    },
    produce = ({ commit }, { shop }) => {
        if (shop.amount > 0) {
            commit(types.PRODUCE, { shop });
        }
    },
    calculateEarnings = ({ commit }, { shop }) => {
        commit(types.CALCULATE_EARNINGS, { shop });
    },
    checkAchievements = (store, { checkBalance }) => {
        /* eslint-disable indent */
        /* eslint-disable arrow-body-style */
        const currentMinBranchAmount = store.state.shops.all.reduce((acc, shop) => (acc.amount > shop.amount ? shop : acc)).amount,
              nonAchieved            = store.state.achievements.all.filter(obj => obj.isAchieved === false && obj.type !== 'autoUpgrade'),
              balance                = store.state.game.balance;
        //@todo: exec balanceWatcher(); when there are no balance achievements left?
        nonAchieved.forEach(achievement => {
            if (checkBalance === true && achievement.type === 'balance' && balance.gte(achievement.balance)) {
                store.commit('ACHIEVE', { achievement });
            } else if (achievement.type === 'shopAmount' && currentMinBranchAmount >= achievement.branches) {
                // a new achievement is unlocked
                store.commit('ACHIEVE', { achievement });
            }
        });
    };
